import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { CloseOrderBatchInput } from './CloseOrderBatchInput';
import { CloseOrderBatchOutput } from './CloseOrderBatchOutput';

export class CloseOrderBatchService extends HttpServiceBase {

  handle = (input: CloseOrderBatchInput): Promise<Result<CloseOrderBatchOutput> | null> => {
    const promise = this.http.put<Result<CloseOrderBatchOutput>, CloseOrderBatchInput>(`${this.baseUrlSislogApi}/v2/order/batch/close`, input);
    return promise;
  }
}